export const initialState = {
    areas: [],
    businessUnits: [],
    coaches: [],
    competencies: [],
    courses: [],
    departments: [],
    downline: true,
    goals: [],
    homeWhatsHappening: {
        show: '',
        data: [],
    },
    languages: [],
    leaderboard: {
        loading: true,
        report: null,
    },
    locations: [],
    metrics: [],
    profiles: [],
    roles: [],
    teams: [],
    team: null,
};
